define('app-FAQNew/main',['./settings', 'sieve'], function (settings) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log('No "FaqsNew" Container found.  app-FaqsNew will not be available.');
                return;
            }

            if ((container).hasClass('cruiseFAQs')) {
                function headerClear() {
                    $(".accordion").each(function () {

                        var numItems = $('.accordion-group .accordion-toggle:visible', this).length;
                        if (numItems === 0) {
                            $(this).addClass('hideHeader');
                        } else {
                            $(this).removeClass('hideHeader');
                        };
                    });
                    $('.noResults').hide();
                }


                //input search;
                $(".searchInput").sieve();
                var searchName = $(".searchInput").attr('search-data');
                var searchPlaceholder = $(".searchInput input").attr('placeholder');
                //Onclick of filters show/hide group
                $(".faqQuestion").on("click", function (e) {
                    e.preventDefault();

                    if (!$(this).hasClass("active")) {
                        $('.faqQuestion').parent().removeClass('active');
                        $(this).parent().addClass('active');

                        if ($(this).hasClass("allQuestions")) {
                            $(".searchBar input").val('').change();
                            $(".accordion").show();
                            var value = $(this).html();
                            $('.searchBar input').val(value);
                            $(".searchBar").addClass('selected');

                        }
                        else {
                            var id = $(this).attr("data-id");
                            $(".searchBar input").val('').change();
                            $(".accordion").hide();

                            $('#' + id).show();
                            $('#' + id).find('.searchBar').show();
                            $('#' + id).get(0).scrollIntoView({ behavior: 'smooth' });

                            var sectionHeader = $('#' + id).find(".sectionHeader").text();
                            var placeholder = "'" + sectionHeader + "' topics";
                            var value = $(this).html();
                            $('.searchBar input').val(value);
                            $(".searchBar").addClass('selected');
                        }
                        headerClear();
                    }
                    $('#FaqsNew .accordion-group').removeClass('active');
                    $('#FaqsNew .accordion-body').hide();
                });
                $(".faqCatagories li span").on("click", function (e) {
                    e.preventDefault();
                    $(this).parent().removeClass('active');
                    $(".searchBar input").attr('placeholder', searchPlaceholder).val('');
                    $(".searchBar").removeClass('selected');
                    $(".accordion").show();
                    headerClear();
                });
                $(".searchBar span").on("click", function (e) {
                    e.preventDefault();
                    $(".searchInput").sieve();
                    $(".searchBar input").attr('placeholder', searchPlaceholder).val('');
                    $(".searchBar").removeClass('selected');
                    $(".faqCatagories li").removeClass('active');
                    $(".accordion").show();
                    $(".question").show();
                    $(".faqCatagories").show();

                    headerClear();
                });
                $(".searchBar input").keypress(function () {
                    if (this.selectionStart == 0) {
                        $(".searchBar input").attr('placeholder', searchPlaceholder).val('');
                        $(".faqCatagories li").removeClass('active');
                        $(".accordion").show();
                        headerClear();
                    }
                    if ($(window).width() < 992) {
                            $(".faqCatagories-inner h4").removeClass('active');
                            $(".faqCatagories-inner ul").hide();
                    }  
                });
                $(".searchBar input").keyup(function () {


                    if (this.selectionStart == 0) {
                        $(".searchBar").removeClass('selected');
                        $(".faqCatagories").show();
                    }
                    else {
                        $(".searchBar").addClass('selected');
                        $(".faqCatagories").hide();
                        
                    }
                    if (!$('.question').is(":visible")) {
                        $('.noResults').show();
                        $(".faqCatagories").show();

                    }
                    else {
                        $('.noResults').hide();
                    }

                    $('.question').find('')

                    
                    
                });
               
                    $(".faqCatagories-inner h4").on("click", function (e) {
                        e.preventDefault();
                        
                        if ($(window).width() < 992) {
                        $(this).toggleClass('active');
                            $(".faqCatagories-inner ul").slideToggle();
                        }
                    });
               
                
            }
            else {
                //input search;

                $(".searchInput").sieve();
                var searchName = $(".searchInput").attr('search-data');

                $(".searchBar input").attr('placeholder', searchName).val('');

                //Onclick of filters show/hide group
                $(".faqQuestion").on("click", function (e) {
                    e.preventDefault();

                    if (!$(this).hasClass("active")) {
                        $('.faqQuestion').removeClass('active');
                        $(this).addClass('active');

                        if ($(this).hasClass("allQuestions")) {
                            $(".searchBar input").val('').change();
                            $(".accordion").show();
                            $(".searchBar input").attr('placeholder', searchName).val('');
                        }
                        else {
                            var id = $(this).attr("data-id");
                            $(".searchBar input").val('').change();
                            $(".accordion").hide();

                            $('#' + id).show();
                            $('#' + id).find('.searchBar').show();

                            var sectionHeader = $('#' + id).find(".sectionHeader").text();
                            var placeholder = "'" + sectionHeader + "' quick find";
                            $(".searchBar input").attr('placeholder', placeholder).val('');
                        }
                        $(".accordion").each(function () {

                            var numItems = $('.accordion-group .accordion-toggle:visible', this).length;
                            if (numItems === 0) {
                                $(this).addClass('hideHeader');
                            } else {
                                $(this).removeClass('hideHeader');
                            };
                        });
                    }
                    $('#FaqsNew .accordion-group').removeClass('active');
                    $('#FaqsNew .accordion-body').hide();
                });
            }

            window.loadedModules("app-FAQNew");
        }
    }
});



